import Image from 'next/image';
import Link from 'next/link';

const legalLinks = [
  { label: 'Privacy Policy', href: '/privacy-policy' },
  { label: 'Terms of Service', href: '/terms-of-service' },
  { label: 'Security', href: '/security' },
  { label: 'Report Misuse', href: '/report-misuse' },
  { label: 'Responsible Use Policy', href: '/responsible-use-policy' },
  { label: 'Accessibility Statement', href: '/accessibility' },
];

export default function MarketingFooter() {
  return (
    <footer className="bg-white mt-0 -mt-48 sm:mt-0">
      <div className="mx-auto max-w-6xl px-4 pt-0 pb-10 md:py-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8">
          {/* Logo, then copyright (desktop: same block, logo first) */}
          <div className="flex flex-col items-start gap-1 md:gap-2 mt-[50px] sm:mt-0">
            <Link href="/" className="inline-flex items-center shrink-0">
              <Image
                src="/tallymedicare-lockup.png"
                alt="Tally Medicare"
                width={1826}
                height={362}
                className="h-[3.6rem] w-auto object-contain opacity-90 ml-[-4px] md:ml-0"
                sizes="(max-width: 768px) 180px, 220px"
                quality={95}
                priority={false}
              />
            </Link>
            <p className="text-xs text-slate-500 leading-snug font-light order-2">
              © 2026 Tally Medicare. All rights reserved.
            </p>
          </div>

          {/* Legal links */}
          <nav className="flex flex-wrap gap-x-6 gap-y-1" aria-label="Legal and compliance">
            {legalLinks.map(({ label, href }) => (
              <Link
                key={href}
                href={href}
                className="text-xs md:text-sm text-slate-600 hover:text-emerald-800 transition-colors"
              >
                {label}
              </Link>
            ))}
          </nav>
        </div>

        {/* CMS & compliance disclaimer */}
        <div className="mt-8 pt-8">
          <p className="text-xs text-slate-500 leading-snug max-w-4xl">
            <strong className="text-slate-600">Compliance &amp; regulations.</strong>{' '}
            <span className="font-light">Tally Medicare
            is designed to support Medicare agents and agencies in commission tracking and revenue
            recovery. Use of this platform must comply with applicable CMS rules, state insurance
            regulations, and federal and state privacy laws (including HIPAA where applicable).
            Marketing and sales practices remain the responsibility of the agent or agency. For
            CMS-related guidance, refer to CMS.gov and your state department of insurance.</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
